import { type } from "@testing-library/user-event/dist/cjs/utility/type.js";
import {
  assignTripsApi,
  createTripsApi,
  createTripsUsingExcelApi,
  deleteTripsApi,
  getAllTripsApi,
  getTripsByIdApi,
  updateTripsApi,
} from "../../helpers/backend_helper";
import {

  errorMessages,
  getTripsByIdData,
  getTripsList,
  setLoading,
} from "./reducer";

export const getAllTripsList =
  (currentPage, pageSize, searchText, date_filter, from_time, to_time) => async (dispatch) => {
    try {
      dispatch(setLoading({ type: "read", value: true }));
      let response;
      response = getAllTripsApi(currentPage, pageSize, searchText, date_filter, from_time, to_time);
      const data = await response;
      dispatch(getTripsList(data));
      return true
    } catch (error) {
      const errorMessage = error?.response?.data?.errors;
      dispatch(errorMessages(errorMessage));
      return false
    } finally {
      dispatch(setLoading({ type: "read", value: false }));
    }
  };

export const getTripsById = (id) => async (dispatch) => {
  try {
    dispatch(setLoading({ type: "getById", value: true }));
    let response;
    response = getTripsByIdApi(id);
    const data = await response;
    dispatch(getTripsByIdData(data));
    return true
  } catch (error) {
    const errorMessage = error?.response?.data?.errors;
    dispatch(errorMessages(errorMessage));
  } finally {
    dispatch(setLoading({ type: "getById", value: false }));
  }
};

export const createTrips = (data) => async (dispatch) => {
  try {
    dispatch(setLoading({ type: "create", value: true }));

    await createTripsApi(data);
    return { success: true, message: "Trips Successfully Created" };
  } catch (error) {
    const errorMessage = error?.response?.data?.errors;
    dispatch(errorMessages(errorMessage));
    return {
      success: false,
      message: errorMessage || "Failed to create trips",
    }
  } finally {
    dispatch(setLoading({ type: "create", value: false }));
  }
};

export const createTripsUsingExcel = (data) => async (dispatch) => {
  try {
    dispatch(setLoading({ type: "create", value: true }));
    await createTripsUsingExcelApi(data);
    return { success: true, message: "Trips Successfully Created" };
  } catch (error) {
    const errorMessage = error?.response?.data?.errors;
    dispatch(errorMessages(errorMessage));
    return {
      success: false,
      message: errorMessage || "Failed to create trips",
    }

  } finally {
    dispatch(setLoading({ type: "create", value: false }));
  }
}

export const updateTrips = (id, data) => async (dispatch) => {
  try {
    dispatch(setLoading({ type: "update", value: true }));
    await updateTripsApi(id, data);
    return { success: true, message: "Trips Successfully Updated" }
  } catch (error) {
    const errorMessage = error?.response?.data?.errors;
    dispatch(errorMessages(errorMessage));
    return { success: false, message: errorMessage || "Failed to update trips" }
  } finally {
    dispatch(setLoading({ type: "update", value: false }));
  }
};

export const assignTrips = (id, data) => async (dispatch) => {
  try {
    dispatch(setLoading({ type: "assign", value: true }));
    await assignTripsApi(id, data);
    return { success: true, message: "Trips Successfully Updated" }
  } catch (error) {
    const errorMessage = error?.response?.data?.errors;
    dispatch(errorMessages(errorMessage));
    return { success: false, message: errorMessage || "Failed to update trips" }
  } finally {
    dispatch(setLoading({ type: "assign", value: false }));
  }
};

export const deleteTrips = (id) => async (dispatch) => {
  try {
    dispatch(setLoading({ type: "delete", value: true }));
    await deleteTripsApi(id);
    return { success: true, message: "Trips Successfully Deleted" };
  } catch (error) {
    const errorMessage = error?.response?.data?.errors;
    dispatch(errorMessages(errorMessage));
    return { success: false, message: errorMessage || "Failed to delete trips" };
  } finally {
    dispatch(setLoading({ type: "delete", value: false }));
  }
};
